export default __webpack_public_path__ + "static/media/diversity4.094a10a0.webp";